import React, { useEffect, useState } from "react";
import $ from "jquery";
import DatePicker from "react-datepicker"; // For date fields
import "react-datepicker/dist/react-datepicker.css"; // Import DatePicker styles
import { useSearchParams, useNavigate } from "react-router-dom";
 
import { FastForward } from "lucide-react";
import api from "../../api/axiosInstance";
const FormPreview = ({ formData, onRefresh }) => {
  debugger;
  const [formValues, setFormValues] = useState({});
  const readonlyMode = [121440001, 121440002, 121440003].includes(
    formData?.form?.statusReasonValue
  );
  const [blocked, setBlocked] = useState(false);
  const [selectedReviewerId, setSelectedReviewerId] = useState("");
  const [reviewerList, setReviewerList] = useState([]);
  const userData = JSON.parse(localStorage.getItem("user")); // Get user info from localStorage
  const userId = userData ? userData.id : null; // Get logged-in user email
  const userDm=userData;
  const shouldDisableFields = false;
  const [queryParams] = useSearchParams();
  const flag = queryParams.get("flag"); // 🔥 <--- THIS LINE extracts the flag
  const [showShareModal, setShowShareModal] = useState(false);
  const [contacts, setContacts] = useState([]);
  const [selectedContacts, setSelectedContacts] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const filteredContacts = contacts.filter((contact) =>
    contact.name.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const [comments, setComments] = useState([]);
  const [showCommentModal, setShowCommentModal] = useState(false);
  const [newCommentText, setNewCommentText] = useState("");
  const [attachments, setAttachments] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);

  
  const showAttachmentSection=
    ((userId === formData.form.submitterId && formData.form.allowSubmitterToAddAttachment)&& (formData.form.statusReasonValue===1|| formData.form.statusReasonValue===121440000))||
    ((formData.form.allowReviewerToAddAttachment) && (formData.form.statusReasonValue===121440001)) ||
  ((formData.form.reviewerId===userId || formData.form.recipientJobCategoryId=== userData.jobCategoryId)&&(formData.form.statusReasonValue===121440001 && formData.form.allowReviewerToAddAttachment)) ||
  ((formData.form.reviewerId!==userId || formData.form.recipientJobCategoryId!== userData.jobCategoryId ) &&( formData.form.allowOthersToAddComment));

      const showCommentSection =
  ((userId === formData.form.submitterId && formData.form.allowSubmitterToAddComment)&& (formData.form.statusReasonValue===1|| formData.form.statusReasonValue===121440000))||
    ((formData.form.allowReviewerToAddComment) && (formData.form.statusReasonValue===121440001)) ||
  ((formData.form.reviewerId===userId || formData.form.recipientJobCategoryId=== userData.jobCategoryId)&&(formData.form.statusReasonValue===121440001 && formData.form.allowReviewerToAddComment)) ||
  ((formData.form.reviewerId!==userId || formData.form.recipientJobCategoryId!== userData.jobCategoryId ) &&( formData.form.allowOthersToAddComment));

  const showPrint=
  (userId === formData.form.submitterId && formData.form.allowSubmitterToPrint) ||
  ((userId === formData.form.reviewerId || formData.form.recipientJobCategoryId=== userData.jobCategoryId ) && (formData.form.allowReviewerToPrint)) ||
   ((formData.form.reviewerId!==userId || formData.form.recipientJobCategoryId!== userData.jobCategoryId ) &&( formData.form.allowOthersToPrint));
  

  const handlePrint = () => {
    window.print();
  };

  useEffect(() => {
    if (showCommentSection) {
      api
        .get(
          `/FormComment/GetFormComments?formId=${formData.form.id}`
        )
        .then((res) => {
          debugger;
          setComments(res.data);
        })
        .catch((err) => {
          debugger;
          console.error("Error loading comments:", err);
        });
    }
  }, [formData.form.id]);

  const fetchAttachments = () => {
    debugger;
    api
      .get(
        `/FormAttachment/GetFormAttachments?formId=${formData.form.id}`
      )
      .then((res) => setAttachments(res.data))
      .catch((err) => console.error("Error fetching attachments:", err));
  };

  const handleUploadAttachment = () => {
 if (!selectedFile) {
   $.alert({
          title: "",
          content: "Please select a file.",
          type: "red",
        });
  return;
  }

    const formDataToSend = new FormData();
    formDataToSend.append("File", selectedFile);
    formDataToSend.append("FormId", formData.form.id);
    formDataToSend.append("ContactName", userData.fullName); // 🧠 logged-in user's name

    api
      .post(
        "/FormAttachment/UploadAttachment",
        formDataToSend
      )
      .then((res) => {
        if (res.data.success) {
          $.alert({
            title: "Success",
            content: "Attachment uploaded successfully.",
            type: "green",
          });
          setSelectedFile(null);
          fetchAttachments();
        } else {
            $.alert({
            title: "Error",
            content: "Upload failed.",
            type: "red",
          });
        }
      })
      .catch((err) => {
        console.error("Upload error:", err);
          $.alert({
            title: "Error",
            content: "Upload error occurred.",
            type: "red",
          });
      });
  };

  const handleDeleteAttachment = (noteId) => {
    if (!window)
    {
      $.confirm(
        {
           title: "Error",
            content: "Are you sure to delete this attachment?",
            type: "red",
        }
      );
       return;
  }

    api
      .delete(
        `/FormAttachment/DeleteAttachment/${noteId}`
      )
      .then((res) => {
        if (res.data.success) {
           $.alert({
            title: "Success",
            content: "Attachment Deleted Successfully",
            type: "green",
          });
          fetchAttachments();
        }
      })
      .catch((err) => console.error("Delete error:", err));
  };

  const handleDownloadAttachment = (noteId, fileName) => {
    api
      .get(
        `/FormAttachment/DownloadAttachment?noteId=${noteId}`,
        {
          responseType: "blob",
        }
      )
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch((err) => console.error("Download error:", err));
  };

  const handleCommentSubmit = () => {
    if (!newCommentText.trim()) {
      alert("Comment cannot be empty.");
      return;
    }

    const payload = {
      formId: formData.form.id,
      comment: newCommentText.trim(),
      contactId: userId,
    };

    api
      .post("/FormComment/AddComment", payload)
      .then((response) => {
        if (response?.data?.success) {
             $.alert({
          title: "Success",
          content: "Comment added successfully.",
          type: "green",
        });
          setShowCommentModal(false);
          setNewCommentText("");

          // Refresh the comments
          api
            .get(
              `/FormComment/GetFormComments?formId=${formData.form.id}`
            )
            .then((res) => {
              setComments(res.data);
            })
            .catch((err) => {
              console.error("Error fetching comments:", err);
            });
        } else {
          alert("Failed to add comment.");
        }
      })
      .catch((err) => {
        console.error("Add comment error:", err);
        alert("An error occurred while adding comment.");
      });
  };

  const handleShareSubmit = () => {
    debugger;
    const payload = selectedContacts.map((contactId) => {
      const contact = contacts.find((c) => c.id === contactId);
      return {
        formId: formData.form.id, // or formData.formId, if that's the correct key
        formName: formData.form.name,
        contactId: contact.id,
        contactName: contact.name, // <-- Include this
        name: contact.name,
        sharedOn: new Date().toLocaleString(),
      };
    });

    api
      .post("/Form/ShareForm", payload, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        // alert("Form shared successfully!");
        $.confirm({
          title: "Success",
          content: "Form shared successfully!",
          buttons: {
            confirm: {
              text: "OK",
              btnClass: "btn-success",
            },
          },
        });
        setShowShareModal(false);
      })
      .catch((error) => {
        console.error(
          "Error sharing form:",
          error.response?.data || error.message
        );
        alert("Failed to share form.");
      });
  };

  useEffect(() => {
    if (showShareModal && formData?.form?.recipientJobCategoryId) {
      api
        .get(
          `/MyForms/GetContactsByJobCategory?jobCategoryId=${formData.form.recipientJobCategoryId}`
        )
        .then((res) => {
          debugger;
          const SharingList = res.data.filter((x) => x.id !== userId);
          setContacts(SharingList);
        })
        .catch((err) => {
          debugger;
          console.error("Error loading contacts:", err);
        });
    }
  }, [showShareModal, formData?.recipientJobCategoryId]);

  const populateComponentValues = (updatedFormData, formValues) => {
    updatedFormData.listSections?.forEach((section) => {
      section.listComponent?.forEach((component) => {
        const id = component.id;
        const value = formValues?.[id];

        switch (component.typeText) {
          case "Label & Number Textbox":
            component.numberTextboxValue =
              value != null
                ? parseFloat(value) || 0
                : component.numberTextboxValue || 0;
            break;

          case "Label & Single Line Textbox":
            component.singleLineTextboxValue =
              value != null ? value : component.singleLineTextboxValue || "";
            break;

          case "Label & Multiline Textbox":
            component.multilineTextboxValue =
              value != null ? value : component.multilineTextboxValue || "";
            break;

          case "Label & Date Textbox":
            const rawDate = value?.toString();
            const isEmptyOrMin =
              !rawDate ||
              rawDate === "0001-01-01T00:00:00" ||
              rawDate === "0001-01-01" ||
              isNaN(new Date(rawDate));
            component.dateTextboxValue = isEmptyOrMin
              ? null
              : new Date(rawDate).toISOString();
            break;

          case "Label & Radio Buttons":
            // radio value might be string or number; keep as integer
            component.radioButtonsValue =
              value != null
                ? parseInt(value, 10) || 0
                : component.radioButtonsValue || 0;
            break;

          case "Label & Listbox":
            component.listboxValue =
              value != null ? value : component.listboxValue || "";
            break;

          case "Label & Checkboxes":
            // value expected as object { checkboxOpt1Value: true, ... }
            const checkboxObj = value || {};
            for (let i = 1; i <= 30; i++) {
              component[`checkboxOpt${i}Value`] =
                !!checkboxObj[`checkboxOpt${i}Value`];
            }
            component.checkboxes = Object.values(checkboxObj).filter(
              (v) => v === true
            ).length;
            break;

          case "Table":
          case "Label & Table":
            if (value && typeof value === "object") {
              // you store table values in value.values according to your earlier code
              component.tableValues = value.values || {};
              component.tableValuesId = value.tableValueId || null;
            }
            break;

          default:
          // no-op
        }
      });
    });
  };

  const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "10px",
    border: "1px solid #ccc",
  };

  const tableHeaderStyle = {
    backgroundColor: "#007bff", // Blue header
    color: "white",
    fontWeight: "bold",
    padding: "10px",
    textAlign: "left",
    borderBottom: "2px solid #0056b3",
  };

  const tableRowStyleEven = {
    backgroundColor: "#f9f9f9", // Light gray row
  };

  const tableRowStyleOdd = {
    backgroundColor: "#ffffff", // White row
  };

  const tableCellStyle = {
    padding: "10px",
    borderBottom: "1px solid #ddd",
  };

  const tableInputStyle = {
    width: "100%",
    padding: "8px",
    border: "1px solid #ccc",
    borderRadius: "4px",
    fontSize: "14px",
    backgroundColor: "#f7f9fc",
  };
  const formContainerStyle = {
    width: "90%",
    margin: "auto",
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "8px",
    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
    border: "1px solid #ddd",
  };

  const sectionHeaderStyle = {
    backgroundColor: "#f7f7f7",
    padding: "10px",
    borderRadius: "6px",
    fontSize: "18px",
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: "15px",
  };
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const recordGuidStr = searchParams.get("recordGuidStr"); // Extract ID from URL query params

  const handleBackClick = () => {
    if (flag === "myForm") {
      navigate(`/editor/MyForms`);
    } else {
      navigate(`/editor/FormsSubmitted`);
    }
  };

  useEffect(() => {
    debugger;
    const initialValues = {};
    var value = "";
    formData.listSections?.forEach((section) => {
      section.listComponent?.forEach((comp) => {
        debugger;
        switch (comp.typeValue) {
          case 121440005: // Single line textbox
            value = comp.singleLineTextboxValue;
            initialValues[comp.id] = value;
            break;
          case 121440008: // Number textbox
            initialValues[comp.id] = comp.numberTextboxValue || "";
            break;

          case 121440006: // Multiline textbox
            initialValues[comp.id] = comp.multilineTextboxValue || "";
            break;

          case 121440007: // Date textbox
            initialValues[comp.id] = comp.dateTextboxValue || "";
            break;

          case 121440009: // Radio button
            initialValues[comp.id] = comp.radioButtonsValue || "";
            break;

          case 121440011: // Dropdown / listbox
            initialValues[comp.id] = comp.listboxValue || "";
            break;

          case 121440010: // Checkbox (multiple options)
            const checkboxes = {};
            for (let i = 1; i <= 30; i++) {
              checkboxes[`checkboxOpt${i}Value`] =
                comp[`checkboxOpt${i}Value`] === true;
            }
            initialValues[comp.id] = checkboxes;
            break;

          case 121440012: {
            // Table
            const tableData = comp.tableValues || {};
            initialValues[comp.id] = {
              tableValueId: comp.tableValuesId || comp.tableValueId || "",
              values: tableData,
            };
            break;
          }

          default:
            break;
        }
      });
    });
    setFormValues(initialValues);
      fetchAttachments();
  }, [formData]);

  useEffect(() => {
    debugger;
    if (formData.form.recipientJobCategoryId) {
      debugger;
      api
        .get(
          `/Form/GetContactsByJobCategory/${formData.form.recipientJobCategoryId}`
        )
        .then((response) => {
          debugger;
          const data = response.data;
          const reviewerList = data.filter((x) => x.id !== userId);
          setReviewerList(reviewerList); // Expected: [{ id, name }]
        })
        .catch((error) => {
          debugger;
          console.error("Error fetching reviewers:", error);
        });
    }
  }, [formData.form.recipientJobCategoryId]);

  function normalizeFormValues(formData, formValues) {
    const normalizedValues = {};

    formData.listSections?.forEach((section, sectionIndex) => {
      section.listComponent?.forEach((component, compIndex) => {
        debugger;
        const id = component.id;
        const type = component.typeText;

        const keyBase = `${sectionIndex}-${compIndex}`;
        let value = "";

        switch (type) {
          case "Label & Number Textbox":
            value = formValues[id];
            break;

          case "Single Line Textbox":
            value = formValues[`${keyBase}-text`] || "";
            break;

          case "Multiline Textbox":
            value = formValues[`${keyBase}-textarea`] || "";
            break;

          case "Date":
            value = formValues[`${keyBase}-date`] || "";
            break;

          // case "Radio Buttons":
          //   value = formValues[`${keyBase}-radio`] || "";
          //   break;

          // case "Dropdown":
          //   value = formValues[`${keyBase}-select`] || "";
          //   break;

          // case "Checkbox":
          //   // checkboxes may be multiple entries
          //   const selected = [];
          //   for (let i = 1; i <= 30; i++) {
          //     const k = `${keyBase}-checkbox-${i}`;
          //     if (formValues[k]) selected.push(formValues[k]);
          //   }
          //   value = selected.join(",");
          //   break;

          default:
            break;
        }

        if (value !== undefined) {
          normalizedValues[id] = value;
        }
      });
    });

    return normalizedValues;
  }
  const Validate = (component) => {
    debugger;
    let valid = true;
  var singleline = $(`#singleline-${component.id}`).val();
    var date = $(`#date-${component.id}`).val();  
    var multiLine = $(`#multiLine-${component.id}`).val();
    var number = $(`#number-${component.id}`).val();
    console.log(component);
if(component.typeValue === 121440007)
{
if(component.isMandatory){
      if (date == null || date === "" )  {
        ActivateDeactivateValidator(`date-${component.id}`, `spandate-${component.id}`, true, "* required");
        valid = false;
      } else {
        ActivateDeactivateValidator(`date-${component.id}`, `spandate-${component.id}`, false, "");
      }
    }
}
if(component.typeValue=== 121440005)
{
  if(component.isMandatory)
  {
     if (singleline == null || singleline === "" ) {
        ActivateDeactivateValidator(
         `singleline-${component.id}`,
         `spansline-${component.id}`,
          true,
          "* required"
        );
        valid = false;
      } else {
        ActivateDeactivateValidator(`singleline-${component.id}`, `spansline-${component.id}`, false, "");
      }
  }
}
if(component.typeValue === 121440006)
{
   if(component.isMandatory){
      if (multiLine == null || multiLine === "" ) {
        ActivateDeactivateValidator(
          `multiLine-${component.id}`,
          `spanMultiLine-${component.id}`,
          true,
          "* required"
        );
      valid = false;
      } else {
        ActivateDeactivateValidator(`multiLine-${component.id}`, `spanMultiLine-${component.id}`, false, "");
      }
    }
}
if(component.typeValue=== 121440008)
{
   if(component.isMandatory){
      if (number == null || number === "") { 
        ActivateDeactivateValidator(`number-${component.id}`, `spannumber-${component.id}`, true, "* required");
        valid = false;
      } else {
        ActivateDeactivateValidator(`number-${component.id}`, `spannumber-${component.id}`, false, "");
      }
    }
}
    if (component.typeValue === 121440009) {
       const isChecked = $(`input[name="radio-${component.id}"]:checked`).length > 0;
if (!isChecked) {
  ActivateDeactivateValidator( null, `spanrad-${component.id}`, true, "* required");
        valid = false;
      } else {
        ActivateDeactivateValidator( null, `spanrad-${component.id}`, false, "");
      }
    
  }
if (component.typeValue === 121440010) {
  const values = formValues[component.id] || {};
  const hasSelection = Object.values(values).some(v => v === true);

  if (!hasSelection) {
    ActivateDeactivateValidator(null, `spancheck-${component.id}`, true, "* required");
    valid = false;
  } else {
    ActivateDeactivateValidator(null, `spancheck-${component.id}`, false, "");
  }
}


  // 3. Listbox (Added component.id to ID strings)
 if (component.typeValue === 121440011) {
  const selectedVal = formValues[component.id];

  if  (!selectedVal || selectedVal === "") {
    ActivateDeactivateValidator(null, `spanlistbox-${component.id}`, true, "* required");
    valid = false;
  } else {
    ActivateDeactivateValidator(null, `spanlistbox-${component.id}`, false, "");
  }
}


  return valid;
};

  const handleSave = (e) => {
    debugger;
    setBlocked(true);
    if (e && e.preventDefault) e.preventDefault();

    return new Promise((resolve, reject) => {
      console.log("Saving full form data with updated values...");

      // Step 1: Deep clone formData to avoid mutating original
      const updatedFormData = JSON.parse(JSON.stringify(formData));

      // 👇 Normalize formValues to map by component.id
      debugger;
      const normalizedValues = normalizeFormValues(updatedFormData, formValues);

      // Step 2: Loop through all sections and components
      updatedFormData.listSections?.forEach((section) => {
        debugger;
        section.listComponent?.forEach((component) => {
          const componentId = component.id;

          if (formValues[componentId] !== undefined) {
            const value = formValues[componentId];

            switch (component.typeText) {
              case "Label & Number Textbox":
                component.numberTextboxValue = parseFloat(value) || 0;
                break;

              case "Label & Single Line Textbox":
                component.singleLineTextboxValue = value;
                break;

              case "Label & Multiline Textbox":
                component.multilineTextboxValue = value;
                break;

              case "Label & Date Textbox":
                // if (value && !isNaN(new Date(value))) {
                //   component.dateTextboxValue = new Date(value).toISOString();
                // } case "Label & Date Textbox":
                const rawDate = value?.toString();
                const isEmptyOrMin =
                  !rawDate ||
                  rawDate === "0001-01-01T00:00:00" ||
                  rawDate === "0001-01-01" ||
                  isNaN(new Date(rawDate));

                component.dateTextboxValue = isEmptyOrMin
                  ? new Date().toISOString() // ⬅️ Use your default here
                  : new Date(rawDate).toISOString();
                break;

                break;

              case "Label & Radio Buttons":
                component.radioButtonsValue = value || 0;
                break;

              case "Label & Listbox":
                component.listboxValue = value;
                break;

              case "Label & Checkboxes":
                const checkboxObj = value || {};
                for (let i = 1; i <= 30; i++) {
                  component[`checkboxOpt${i}Value`] =
                    checkboxObj[`checkboxOpt${i}Value`] === true;
                }
                component.checkboxes = Object.values(value).filter(
                  (v) => v === true
                ).length;
                break;

              case "Table":
              case "Label & Table":
                if (value && typeof value === "object") {
                  component.tableValues = value.values || {};
                  component.tableValuesId = value.tableValueId || null;
                }
                break;

              default:
                console.warn(`Unhandled component type: ${component.typeText}`);
                break;
            }
          }
        });
      });
      // Step 3: Add reviewerId to formData if applicable
      if (selectedReviewerId) {
        updatedFormData.form.reviewerId = selectedReviewerId;
      }

      // Step 3: Send full updated formData to the backend
      debugger;
      api
        .post("/MyForms/SaveForm", updatedFormData, {
          headers: { "Content-Type": "application/json" },
        })
        .then((response) => {
          setBlocked(false);
          $.alert({
            title: "Success",
            content: "Form saved successfully!",
            type: "green",
          });
          resolve(response.data); // ✅ Resolve when save is successful
        })
        .catch((error) => {
          console.error("Save error:", error.response?.data || error.message);
          alert("Error saving form.");
          reject(error); // ❌ Reject if error
        });
    });
  };

  const backdropStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    background: "rgba(0,0,0,0.2)", // light dark shade
    zIndex: 9998,
    cursor: "wait", // cursor changes to loading
  };

  const overlayStyle = {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    background: "#222",
    padding: "30px 50px",
    borderRadius: "12px",
    zIndex: 9999,
    color: "#fff",
    fontSize: "22px",
    textAlign: "center",
    cursor: "wait", // cursor loading
  };

  // function fetchTableValuesFromCRM(tableValueId, onSuccess, onError) {
  //   api
  //     .get(`http://your-backend-url/api/tablevalues/${tableValueId}`)
  //     .then((response) => {
  //       const data = response.data;
  //       const values = {};

  //       for (let r = 1; r <= 15; r++) {
  //         for (let c = 1; c <= 6; c++) {
  //           const key = `C${c}R${r}`;
  //           if (data[key] !== undefined && data[key] !== null) {
  //             values[key] = data[key];
  //           }
  //         }
  //       }

  //       onSuccess({
  //         tableValueId: data.tableValueId,
  //         values: values
  //       });
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching table values:", error);
  //       if (onError) {
  //         onError(error;)
  //       }
  //     });
  // }


  const ActivateDeactivateValidator = (
    controlName,
    validatorName,
    activate,
    message
  ) => {
    debugger;
    if (activate === true) {
      $("#" + validatorName)
        .removeClass("field-validation-valid")
        .addClass("field-validation-error")
        .text(message)
        .focus();
      $("#" + controlName).focus();
    } else {
      $("#" + validatorName)
        .removeClass("field-validation-error")
        .addClass("field-validation-valid")
        .text("");
    }
  };
  const handleSubmit = async () => {
    debugger;
    setBlocked(true);

    try {
      // 🔥 Validate whole form before submit
      const updatedFormData = JSON.parse(JSON.stringify(formData));

      // 👇 Normalize formValues to map by component.id
      populateComponentValues(updatedFormData, formValues);
       const allValid = ValidateAllComponents(updatedFormData);
        if ( !allValid) {
        setBlocked(false);
        return;
      }

      // 🔄 Save after validation passes
      await handleSave(true);

      debugger;
      // 🔥 Mark as submitted
      await api.post(
        `/MyForms/UpdateStatus?formId=${formData.form.id}`,
        JSON.stringify(121440001),
        { headers: { "Content-Type": "application/json" } }
      );
      debugger;
      onRefresh();

      setBlocked(false);

      $.alert({
        title: "Success",
        content: "Form submitted and marked as completed!",
        type: "green",
      });
    } catch (error) {
      alert("Error while submitting the form.");
      setBlocked(false);
      console.error("Submit error:", error);
    }
  };

  const ValidateAllComponents = (formData) => {
    let valid = true;

    formData.listSections?.forEach((section) => {
      section.listComponent?.forEach((component) => {
        debugger;
        if (!Validate(component)) {
          valid = false;
        }
      });
    });

    return valid;
  };

  const handleFormStatusUpdate = (statusValue) => {
    debugger;
    api
      .post(
        `/MyForms/UpdateStatus?formId=${formData.form.id}`,
        statusValue,
        {
          headers: { "Content-Type": "application/json" },
        }
      )
      .then((response) => {
        onRefresh();
         $.alert({
        title: "Success",
        content: "Form status updated successfully.",
        type: "green",
      });
        console.log(response.data);
      })
      .catch((error) => {
        console.error(
          "Error updating status:",
          error.response?.data || error.message
        );
        
        alert("Failed to update form status.");
      });
  };

  // Render form elements based on TypeValue
  // Render form elements based on TypeValue
  const renderColumn = (column, rowIndex, columnIndex) => {
    const labelStyle = {
      fontSize: "16px",
      fontWeight: "bold",
      marginBottom: "4px",
      display: "block",
      minWidth: "120px", // Ensures labels are aligned
    };

    const inputStyle = {
      width: "100%",
      padding: "5px",
      border: "1px solid #ccc",
      borderRadius: "4px",
      fontSize: "14px",
    };

    const optionContainerStyle = {
      // display: "grid",
      // gridTemplateColumns: `auto auto auto`,
      // gap: "10px",
      alignItems: "center",
    };

    const handleOperandChange = (componentId, value) => {
      debugger;
      setFormValues((prev) => {
        let updated = { ...prev, [componentId]: value };
        let hasChanged = true;

        while (hasChanged) {
          hasChanged = false;

          formData.listCalculation.forEach((calc) => {
            const aVal = parseFloat(updated[calc.operandAId]) || 0;
            const bVal = parseFloat(updated[calc.operandBId]) || 0;
            let result = 0;

            switch (calc.operatorText) {
              case "Add":
                result = aVal + bVal;
                break;
              case "Subtract":
                result = aVal - bVal;
                break;
              case "Multiply":
                result = aVal * bVal;
                break;
              case "Divide":
                result = bVal !== 0 ? aVal / bVal : 0;
                break;
            }

            if (updated[calc.resultId] !== result) {
              updated[calc.resultId] = result;
              hasChanged = true;
            }
          });
        }

        return updated;
      });
    };

    switch (column.typeValue) {
      case 121440002:
        return (
          <h3
            style={{
              textAlign: "center",
              fontSize: "24px",
              fontWeight: "bold",
            }}
          >
            {column.header}
          </h3>
        );
      case 121440003:
        return (
          <h4
            style={{
              textAlign: "left",
              fontSize: "20px",
              fontWeight: "bold",
              marginLeft: "10px",
            }}
          >
            {column.subHeader}
          </h4>
        );
      case 121440004:
        return (
          <div>
            {column.onlyTextParas && column.onlyTextParas.length > 0
              ? column.onlyTextParas.map((str, index) =>
                  str.trim() !== "" ? (
                    <p
                      key={index}
                      style={{ textAlign: "left", marginBottom: 0 }}
                    >
                      {str}
                    </p>
                  ) : (
                    <br key={index} />
                  )
                )
              : null}
          </div>
        );
      case 121440005:
        debugger;

        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label style={labelStyle}>
              {column.singleLineTextboxLabel}
              {column.isMandatory && <span style={{ color: "red" }}> *</span>}
            </label>
            <input
              id={`singleline-${column.id}`}
              type="text"
              style={inputStyle}
              value={formValues[column.id] || ""}
              onChange={(e) =>
                setFormValues({ ...formValues, [column.id]: e.target.value })
              }
              maxLength={200}
              disabled={readonlyMode} // ✅ Add this
            />
            <span
              id={`spansline-${column.id}`}
              className="field-validation-valid"
              style={{ color: "red" }}  
            ></span>
          </div>
        );
      case 121440006:
        return (
          <div style={{ marginBottom: "20px" }}>
            <label
              style={{
                display: "block",
                fontWeight: "bold",
                marginBottom: "8px",
                color: "#374151", // Tailwind's gray-700
              }}
            >
              {column.multilineTextboxLabel}
              {column.isMandatory && <span style={{ color: "red" }}> *</span>}
            </label>

            <textarea
              id={`multiLine-${column.id}`}
              rows={column.mltxtRows}
              maxLength={5000}
              value={formValues[column.id] || ""}
              onChange={(e) =>
                setFormValues({ ...formValues, [column.id]: e.target.value })
              }
              disabled={readonlyMode}
              placeholder="Enter your response..."
              style={{
                width: "100%",
                padding: "12px",
                borderRadius: "8px",
                border: "1px solid #d1d5db", // Tailwind's gray-300
                backgroundColor: readonlyMode ? "#f9fafb" : "#ffffff",
                resize: "vertical",
                fontSize: "14px",
                color: "#111827", // gray-900
                outline: "none",
                boxShadow: readonlyMode ? "none" : "0 1px 2px rgba(0,0,0,0.05)",
              }}
            />
            <span
              id={`spanMultiLine-${column.id}`}
              className="field-validation-valid"
              style={{ color: "red" }}
            ></span>
          </div>
        );

      case 121440007:
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label style={labelStyle}>
              {column.dateTextboxLabel}
              {column.isMandatory && <span style={{ color: "red" }}> *</span>}
            </label>
            <input
              id={`date-${column.id}`}
              type="date"
              style={inputStyle}
              value={
                formValues[column.id]
                  ? new Date(formValues[column.id]).toISOString().split("T")[0]
                  : ""
              }
              onChange={(e) =>
                setFormValues({ ...formValues, [column.id]: e.target.value })
              }
              disabled={readonlyMode}
              maxLength={200}
            />
            <span
              id={`spandate-${column.id}`}
              className="field-validation-valid"
              style={{ color: "red" }}
            ></span>
          </div>
        );

      case 121440008:
        debugger;
        const componentId = column.id; // your unique component I
        const label = column.numberTextboxLabel || "Number Input";

        const value = formValues[componentId] || ""; // get current value

        const isOperand = formData.listCalculation.some(
          (calc) =>
            calc.operandAId === componentId || calc.operandBId === componentId
        );

        const isResult = formData.listCalculation.some(
          (calc) => calc.resultId === componentId
        );

        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label style={labelStyle}>
              {column.numberTextboxLabel}
              {column.isMandatory && <span style={{ color: "red" }}> *</span>}
            </label>
            <input
              id={`number-${column.id}`}
              type="number"
              style={inputStyle}
              value={formValues[componentId] || ""}
              onChange={
                isOperand
                  ? (e) => handleOperandChange(componentId, e.target.value)
                  : (e) =>
                      setFormValues((prev) => ({
                        ...prev,
                        [componentId]: e.target.value,
                      }))
              }
              maxLength={100}
              disabled={readonlyMode} // ✅ Add this
            />
            <span
              id={`spannumber-${column.id}`}
              className="field-validation-valid"
              style={{ color: "red" }}
            ></span>
          </div>
        );

      case 121440009:
        const radioOptions = [];
        for (let i = 1; i <= 30; i++) {
          const label = column[`radioButtonOpt${i}Label`];
          if (label) {
            radioOptions.push({ value: i.toString(), text: label });
          }
        }

        const compId = column.id;
        const selected = formValues[compId]?.toString();

        return (
          <div style={{ marginBottom: "20px" }}>
            <label
              style={{
                fontWeight: "bold",
                fontSize: "16px",
                marginBottom: "8px",
                display: "block",
              }}
            >
              {column.radioButtonsLabel}
              <span style={{ color: "red" }}> *</span>
            </label>

            <div style={{ display: "flex", flexWrap: "wrap", gap: "15px" }}>
              {radioOptions.map((option, index) => (
                <label
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    backgroundColor: "#f8f9fa",
                    padding: "6px 12px",
                    borderRadius: "8px",
                    border: "1px solid #ddd",
                    cursor: readonlyMode ? "not-allowed" : "pointer",
                  }}
                >
                  <input
                    type="radio"
                    name={`radio-${column.id}`}
                    value={option.value}
                    checked={selected === option.value}
                    onChange={(e) =>
                      setFormValues((prev) => ({
                        ...prev,
                        [compId]: e.target.value,
                      }))
                    }
                    disabled={readonlyMode}
                    style={{ accentColor: "#007bff" }}
                     maxLength={200}
                  />
                  {option.text}
                  
                </label>
              ))}
            </div>
            <span
              id={`spanrad-${column.id}`}
              className="field-validation-valid"
              style={{ color: "red" }}
            ></span>
          </div>
        );

      case 121440010:
        const checkboxOptions = [];
        for (let i = 1; i <= 30; i++) {
          const label = column[`checkboxOpt${i}Label`];
          if (label) {
            checkboxOptions.push({
              key: `checkboxOpt${i}`,
              valueKey: `checkboxOpt${i}Value`,
              value: i,
              text: label,
            });
          }
        }

        const compid = column.id;
        // Put this near top-level in your component

        const handleCheckboxChange = (key) => {
          setFormValues((prev) => ({
            ...prev,
            [compid]: {
              ...prev[compid],
              [key]: !prev[compid]?.[key],
            },
          }));
        };

        return (
          <div style={{ marginBottom: "20px" }}>
            <label
              style={{
                fontWeight: "bold",
                fontSize: "16px",
                marginBottom: "8px",
                display: "block",
              }}
            >
              {column.checkboxLabel}
              <span style={{ color: "red" }}> *</span>
            </label>

            <div style={{ display: "flex", flexWrap: "wrap", gap: "15px" }}>
              {checkboxOptions.map((option, index) => {
                const isChecked =
                  formValues[compid]?.[option.valueKey] === true;

                return (
                  <div>
                    <label
                      key={index}
                      htmlFor={`${compid}-${option.key}`}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        backgroundColor: "#f1f3f5",
                        padding: "6px 12px",
                        borderRadius: "8px",
                        border: "1px solid #ccc",
                        cursor: readonlyMode ? "not-allowed" : "pointer",
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={() => handleCheckboxChange(option.valueKey)}
                        disabled={readonlyMode}
                        style={{ accentColor: "#28a745" }}
                         maxLength={200}
                      />
                      {option.text}
                    </label>
                  </div>
                );
              })}
                                  <span
                    id={`spancheck-${column.id}`}
                      className="field-validation-valid"
                      style={{ color: "red" }}
                    ></span>
            </div>
          </div>
        );

      case 121440011:
        const listboxOptions = [];
        for (let i = 1; i <= 30; i++) {
          const label = column[`listboxOpt${i}Label`];
          if (label) {
            listboxOptions.push({ value: i.toString(), text: label });
          }
        }
        const comp = column.id;
        const selectedValue = formValues[comp] ? String(formValues[comp]) : "";

        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label style={{ fontSize: "16px", fontWeight: "bold", marginBottom: "6px" }}>
              {column.listboxLabel}&nbsp;: &nbsp;
        <span style={{ color: "red" }}> *</span>
            </label>

            <select
              value={formValues[comp] || ""}
              onChange={(e) =>
                setFormValues((prev) => ({
                  ...prev,
                  [comp]: e.target.value,
                }))
              }
               disabled={readonlyMode} // ✅ Add this 
              style={{
                width: "100%",
                padding: "5px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                fontSize: "14px",
                backgroundColor: "#f7f9fc",
                cursor: "pointer",
                outline: "none",
                appearance: "none",
                backgroundImage:
                  "url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" fill=\"black\"><path fill-rule=\"evenodd\" d=\"M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z\" clip-rule=\"evenodd\"/></svg>')",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "right 10px center",
                backgroundSize: "12px",
              }}
            >
              <option value="">-- Select --</option>
              {listboxOptions.map((option, index) => (
                <option key={index} value={option.value}>
                  {option.text}
                </option>
              ))}
            </select>
            <span
              id={`spanlistbox-${column.id}`}
              className="field-validation-valid"
              style={{ color: "red" }}
            ></span>
          </div>
        );
      // 👇 The actual Table component inside your switch-case
      case 121440012: {
        debugger;
        const tableHeaders = [];
        for (let i = 1; i <= 6; i++) {
          const header = column[`tableHeader${i}`];
          if (header?.trim()) {
            tableHeaders.push({ value: i.toString(), text: header.trim() });
          }
        }

        const numberOfRows = Number(column.tableRows) || 1;

        const existingValues = formValues[column.id]?.values;
        const existingTableValueId = formValues[column.id]?.tableValueId;

        const tableData = existingValues || column.tableValues || {};
        const tableValueId =
          existingTableValueId || column.tableValuesId || column.tableValueId;

        return (
          <div>
            <label
              style={{
                fontWeight: "bold",
                fontSize: "16px",
                marginBottom: "8px",
                display: "block",
                textAlign: "center",
              }}
            >
              {column.tableLabel}
            </label>
            <table style={tableStyle}>
              <thead>
                <tr>
                  {tableHeaders.map((option, index) => (
                    <th key={index} style={tableHeaderStyle}>
                      {option.text}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {Array.from({ length: numberOfRows }).map((_, rowIdx) => (
                  <tr
                    key={rowIdx}
                    style={
                      rowIdx % 2 === 0 ? tableRowStyleEven : tableRowStyleOdd
                    }
                  >
                    {tableHeaders.map((_, colIdx) => {
                      const cellKey = `c${colIdx + 1}R${rowIdx + 1}`; // use lowercase 'c'

                      console.log(
                        "Table Data Keys for column",
                        column.id,
                        Object.keys(tableData)
                      );

                      return (
                        <td key={colIdx} style={tableCellStyle}>
                          <input
                            type="text"
                            maxLength={100}
                            style={tableInputStyle}
                            value={tableData[cellKey] || ""}
                            onChange={(e) => {
                              const newValue = e.target.value;

                              setFormValues((prevFormValues) => {
                                const prevComponent =
                                  prevFormValues[column.id] || {};
                                const prevTableValues =
                                  prevComponent.values || {};

                                // Clone the values
                                const updatedValues = {
                                  ...prevTableValues,
                                  [cellKey]: newValue,
                                };

                                return {
                                  ...prevFormValues,
                                  [column.id]: {
                                    ...prevComponent,
                                    tableValueId: tableValueId,
                                    values: updatedValues,
                                  },
                                };
                              });
                            }}
                            disabled={readonlyMode} // ✅ Add this
                          />
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        );
      }

      default:
        return null;
    }
  };

  return (
    <div>
      {blocked && (
        <>
          {/* FULL SCREEN BACKDROP THAT BLOCKS CLICKS */}
          <div style={backdropStyle}></div>

          {/* CENTER BOX */}
          <div style={overlayStyle}>
            <div className="spinner-border" role="status"></div>
            <div>Please wait…</div>
          </div>
        </>
      )}
      <div style={{ textAlign: "center", marginBottom: "20px" }}>
        <label style={{ fontSize: "16px", fontWeight: "bold" }}>
          Reviewer:&nbsp;
        </label>

        {formData.form.allowSubmitterToSelectReviewer &&
        formData.form.recipientJobCategoryId ? (
          <select
            value={selectedReviewerId || formData.form.reviewerId}
            onChange={(e) => setSelectedReviewerId(e.target.value)}
            style={{
              padding: "8px",
              fontSize: "14px",
              borderRadius: "5px",
              border: "1px solid #ccc",
              minWidth: "200px",
            }}
            disabled={readonlyMode} // ✅ Add this
          >
            <option value="">-- Select Reviewer --</option>
            {reviewerList.map((reviewer) => (
              <option key={reviewer.id} value={reviewer.id}>
                {reviewer.name}
              </option>
            ))}
          </select>
        ) : (
          <span style={{ fontSize: "14px", color: "#555" }}>
            {formData.form.reviewerName || "N/A"}
          </span>
        )}
      </div>

      {Array.isArray(formData?.listSections) &&
        formData.listSections.map((section, sectionIndex) => (
          <div key={section.id} style={{ marginBottom: "20px" }}>
            {section.listRows.map((row, rowIndex) => {
              const isFullWidth = row.isFull;

              return (
                <div
                  key={rowIndex}
                  style={{
                    display: "grid",
                    gridTemplateColumns: isFullWidth
                      ? "1fr"
                      : `repeat(${section.noOfColumns}, 1fr)`,
                    gap: "10px",
                    marginBottom: "15px",
                  }}
                >
                  {row.formColumn1 &&
                    renderColumn(row.formColumn1, rowIndex, 1)}
                  {!isFullWidth &&
                    row.formColumn2 &&
                    renderColumn(row.formColumn2, rowIndex, 2)}
                  {!isFullWidth &&
                    row.formColumn3 &&
                    renderColumn(row.formColumn3, rowIndex, 3)}
                  {!isFullWidth &&
                    row.formColumn4 &&
                    renderColumn(row.formColumn4, rowIndex, 4)}
                </div>
              );
            })}
          </div>
        ))}

      {showShareModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            height: "100vh",
            width: "100vw",
            backgroundColor: "rgba(0, 0, 0, 0.4)",
            backdropFilter: "blur(4px)",
            zIndex: 999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              backgroundColor: "#fff",
              padding: "25px",
              borderRadius: "12px",
              width: "500px",
              maxHeight: "80vh",
              overflowY: "auto",
              boxShadow: "0 8px 20px rgba(0, 0, 0, 0.25)",
              position: "relative",
            }}
          >
            <h2 style={{ marginBottom: "10px", color: "#333" }}>
              Select Contacts to Share
            </h2>

            {/* 🔍 Search Bar */}
            <input
              type="text"
              placeholder="Search contacts..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              style={{
                width: "100%",
                padding: "8px 10px",
                marginBottom: "15px",
                borderRadius: "6px",
                border: "1px solid #ccc",
                fontSize: "14px",
              }}
            />

            {/* ✅ Scrollable contact list */}
            <div
              style={{
                maxHeight: "40vh",
                overflowY: "auto",
                marginBottom: "20px",
              }}
            >
              {filteredContacts.map((contact) => (
                <div key={contact.id} style={{ padding: "6px 0" }}>
                  <label style={{ fontSize: "15px", cursor: "pointer" }}>
                    <input
                      type="checkbox"
                      style={{ marginRight: "10px" }}
                      checked={selectedContacts.includes(contact.id)}
                      onChange={(e) => {
                        const newSelection = e.target.checked
                          ? [...selectedContacts, contact.id]
                          : selectedContacts.filter((id) => id !== contact.id);
                        setSelectedContacts(newSelection);
                      }}
                    />
                    {contact.name}
                  </label>
                </div>
              ))}
              {filteredContacts.length === 0 && (
                <div style={{ fontStyle: "italic", color: "#888" }}>
                  No contacts found
                </div>
              )}
            </div>

            {/* Footer Buttons */}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
              }}
            >
              <button
                onClick={handleShareSubmit}
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#2563eb",
                  color: "#fff",
                  border: "none",
                  borderRadius: "6px",
                  fontSize: "14px",
                  cursor: "pointer",
                }}
              >
                Submit
              </button>
              <button
                onClick={() => setShowShareModal(false)}
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#e0e0e0",
                  color: "#333",
                  border: "none",
                  borderRadius: "6px",
                  fontSize: "14px",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px", // equal space between all buttons
          padding: "20px 0",
          flexWrap: "wrap", // responsive (wraps on small screens)
        }}
      >
        {/* Back Button */}
{(formData.form.statusReasonValue === 1 ||
          formData.form.statusReasonValue === 121440000) && (
            <>
        <button
          onClick={handleBackClick}
          style={{
            padding: "8px 16px",
            backgroundColor: "#007bff",
            color: "rgb(255,255,255)",
            border: "none",
            borderRadius: "6px",
            fontSize: "15px",
            fontWeight: "bold",
            cursor: "pointer",
            transition: "all 0.3s ease",
          }}
        >
          Back
        </button>
        </> 
          )}

        {/* Conditional Buttons */}
        {(formData.form.statusReasonValue === 1 ||
          formData.form.statusReasonValue === 121440000) && (
          <>
            {/* Save Button */}
            <button
              type="submit"
              onClick={() => handleSave()}
              style={{
                padding: "8px 16px",
                backgroundColor: "#28a745",
                color: "rgb(255,255,255)",
                border: "none",
                borderRadius: "6px",
                fontSize: "15px",
                fontWeight: "bold",
                cursor: "pointer",
                transition: "all 0.3s ease",
              }}
              readOnly={readonlyMode}
            >
              Save
            </button>

            {/* Submit Button */}
            <button
              type="button"
              onClick={() => handleSubmit()}
              style={{
                padding: "8px 16px",
                backgroundColor: "#ffc107",
                color: "black",
                border: "none",
                borderRadius: "6px",
                fontSize: "15px",
                fontWeight: "bold",
                cursor: "pointer",
                transition: "all 0.3s ease",
              }}
              readOnly={readonlyMode}
            >
              Submit
            </button>
          </>
        )}

        {/* Share Button */}
        {userId === formData.form.submitterId &&
          (formData.form.statusReasonValue === 121440000 ||
            formData.form.statusReasonValue === 1) && (
            <button
              onClick={() => setShowShareModal(true)}
              style={{
                padding: "8px 16px",
                backgroundColor: "#2563eb",
                color: "rgb(255,255,255)",
                border: "none",
                borderRadius: "6px",
                fontSize: "15px",
                fontWeight: "bold",
                cursor: "pointer",
                transition: "all 0.3s ease",
              }}
            >
              Share Form
            </button>
          )}

        {/* Print Button */}
        {showPrint && (
        <button
          type="button"
          onClick={handlePrint}
          style={{
            padding: "8px 16px",
            backgroundColor: "#a50d7a",
            color: "rgb(255,255,255)",
            border: "none",
            borderRadius: "6px",
            fontWeight: "bold",
            fontSize: "15px",
            cursor: "pointer",
            transition: "all 0.3s ease",
          }}
          readOnly={readonlyMode}
        >
          Print
        </button>
        )}

        {(formData.form.statusReasonValue === 121440001 && !(formData.form.statusReasonValue === 121440002
        || formData.form.statusReasonValue === 121440003)) &&
          userId !== formData.form.submitterId && (
            <>
              <button
                onClick={() => handleFormStatusUpdate(121440002)}
                style={{
                  padding: "8px 16px",
                  backgroundColor: "#1f913bff",
                  color: "rgb(255,255,255)",
                  border: "none",
                  borderRadius: "6px",
                  fontSize: "15px",
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
              >
                Approve
              </button>
              <button
                onClick={() => handleFormStatusUpdate(121440003)}
                style={{
                  padding: "8px 16px",
                  backgroundColor: "#10b981",
                  color: "rgb(255,255,255)",
                  border: "none",
                  borderRadius: "6px",
                  fontSize: "15px",
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
              >
                Reject
              </button>
            </>
          )}
      </div>

      {/* 💬 Comment Modal */}
      {showCommentModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            height: "100vh",
            width: "100vw",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            backdropFilter: "blur(5px)",
            zIndex: 1000,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              backgroundColor: "#ffffff",
              padding: "25px",
              borderRadius: "12px",
              width: "90%",
              maxWidth: "500px",
              boxShadow: "0 8px 24px rgba(0, 0, 0, 0.2)",
              animation: "fadeIn 0.3s ease-in-out",
            }}
          >
            <h3
              style={{
                marginBottom: "15px",
                fontSize: "20px",
                fontWeight: "bold",
              }}
            >
              📝 Add a Comment
            </h3>
            <textarea
              value={newCommentText}
              onChange={(e) => setNewCommentText(e.target.value)}
              rows={5}
              placeholder="Write your comment here..."
              style={{
                width: "100%",
                padding: "12px",
                borderRadius: "8px",
                border: "1px solid #d1d5db",
                resize: "vertical",
                marginBottom: "20px",
                fontSize: "14px",
              }}
            ></textarea>

            <div style={{ textAlign: "right" }}>
              <button
                onClick={handleCommentSubmit}
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#3b82f6",
                  color: "white",
                  border: "none",
                  borderRadius: "6px",
                  marginRight: "10px",
                  cursor: "pointer",
                }}
              >
                Submit
              </button>
              <button
                onClick={() => setShowCommentModal(false)}
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#f3f4f6",
                  border: "1px solid #d1d5db",
                  borderRadius: "6px",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 💬 Comments Section */}
        <div style={{ marginTop: "40px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "15px",
            }}
          >
            <h3 style={{ fontSize: "22px", fontWeight: "600" }}>
              💬 Form Comments
            </h3>
          { showCommentSection && (
            <button
              onClick={() => setShowCommentModal(true)}
              style={{
                padding: "8px 16px",
                backgroundColor: "#10b981",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                fontWeight: "bold",
                cursor: "pointer",
              
              }}

            >
              + Add Comment
            </button>
            )}
            

          </div>

          {comments.length === 0 ? (
            <p style={{ color: "#6b7280" }}>No comments yet.</p>
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "15px",
                maxHeight: "300px", // or whatever height fits your layout
                overflowY: "auto",
                paddingRight: "8px", // optional: for better scroll view
              }}
            >
              {comments
                .sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn))
                .map((c, i) => (
                  <div
                    key={i}
                    style={{
                      border: "1px solid #e5e7eb",
                      borderRadius: "8px",
                      padding: "16px",
                      backgroundColor: "#f9fafb",
                      boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                    }}
                  >
                    <p
                      style={{
                        marginBottom: "8px",
                        fontSize: "15px",
                        color: "#111827",
                      }}
                    >
                      {c.comment}
                    </p>
                    <div style={{ fontSize: "13px", color: "#6b7280" }}>
                      <span>👤 {c.contactName || "Unknown"}</span>
                      <span style={{ marginLeft: "12px" }}>
                        🕒 {new Date(c.createdOn).toLocaleString()}
                      </span>
                    </div>
                  </div>
                ))}
            </div>
          )}
        </div>


        <div style={{ marginTop: "30px" }}
          disabled={readonlyMode}>
             <h3 style={{  fontSize: "22px", fontWeight: "600" }}>📎 Form Attachments</h3>
{showAttachmentSection && (
          <div
            style={{
              display: "flex",
              marginBottom: "10px",
              alignItems: "center",
              gap: "12px",
            }}
          >
            <input
              type="file"
              onChange={(e) => setSelectedFile(e.target.files[0])}
              style={{
                border: "1px solid #d1d5db",
                padding: "6px",
                borderRadius: "6px",
              }}
            />
            <button
              onClick={handleUploadAttachment}
              style={{
                padding: "8px 16px",
                backgroundColor: "#3b82f6",
                color: "white",
                border: "none",
                borderRadius: "6px",
                fontWeight: "bold",
              }}
            >
              Upload
            </button>
          </div>
       )}

          <table className="table table-bordered table-sm">
            <thead className="thead-light">
              <tr>
                <th>Added By</th>
                <th>Added On</th>
                <th>File</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {attachments.length === 0 ? (
                <tr>
                  <td colSpan="4" style={{ textAlign: "center" }}>
                    No attachments found.
                  </td>
                </tr>
              ) : (
                attachments.map((a) => (
                  <tr key={a.id}>
                    <td>{a.addedBy}</td>
                    <td>{new Date(a.createdOn).toLocaleString()}</td>
                    <td>{a.fileName}</td>
                    <td>
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={() =>
                          handleDownloadAttachment(a.id, a.fileName)
                        }
                        title="Download"
                      >
                        <i className="fa fa-download" />
                      </button>
                      &nbsp;
                      {userId === formData.form.reviewerId && (
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={() => handleDeleteAttachment(a.id)}
                          title="Delete"
                        >
                          <i className="fa fa-trash" />
                        </button>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
    </div>
  );
};

export default FormPreview;
